export const iconFontAwesomeHandsHandMiddleFinger = (
	<i className="fa-solid fa-hand-middle-finger"></i>
);
